<div class="logging-in">
    <p-progressSpinner [style]="{width: '24px', height: '24px'}" styleClass="custom-spinner" strokeWidth="4"></p-progressSpinner>
    <div class="text">Logging in...</div>
</div>